
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CourseCard extends Vue {
  @Prop({ required: true }) name!: string
  @Prop({ required: true }) room!: string
  @Prop({ required: true }) instructor!: string
  @Prop({ required: true }) url!: string

  dialogVisible = false

  editForm = {
    name: this.name,
    room: this.room,
    instructor: this.instructor,
    url: this.url,
  }

  get isUrlEmpty(): boolean {
    return this.url === ''
  }

  editSubmit(): void {
    this.$emit('update:name', this.editForm.name)
    this.$emit('update:room', this.editForm.room)
    this.$emit('update:instructor', this.editForm.instructor)
    this.$emit('update:url', this.editForm.url)
    this.$emit('update')

    this.dialogVisible = false
  }

  joinZoom(): void {
    window.open(this.url, '_blank')
  }

  deleteData(): void {
    this.$emit('delete')
  }
}
